import { get, post } from "@/http/index.js";
import { USER, REGISTER, MEETING, MEMBER } from "@/utils/http.js";

/**
 * 获取验证码
 * @param {*} mobile
 */
export const getRegisterCode = params =>
  post(MEMBER + "/register/sms/send", params);

/**
 * 验证验证码
 * @param {*} code
 */
export const verifyRegisterCode = params =>
  post(MEMBER + "/register/sms/verify", params);

/**
 * 验证手机号
 * @param {*} mobile
 */
export const checkMobile = params =>
  post(MEMBER + "/register/check/mobile", params);

/*检测登录名
*/
export const checkLogin= params =>
  post(MEMBER + "/register/check/login", params);

/**
 * 找回密码
 */
export const setNewPW = params =>
  post(MEMBER + "/account/change-password2", params);

//修改密码
export const passwordSubmit = params =>
  post(MEMBER + "/account/change-password", params);

/**
 * 快捷注册
 */
export const fastRegisterMember = params =>
  post(MEMBER + "/register/mobile", params);

/**
 * 个人会员注册
 * @param {*} params
 */
export const registerMemberEdit = params =>
  post(MEMBER + "/register/member", params);

/**
 * 团体会员注册
 * @param {*} params
 */
export const registerGroupEdit = params =>
  post(MEMBER + "/register/group", params);

/**
 *团体会员联系人添加
 * @param {*} memberId
 * @param {*} contacts
 */
export const contactSave = params => post(MEMBER + "/contact/save", params);

/**
 * 登录
 * @param {*} username
 * @param {*} password
 * @param {*} grant_type
 * @param {*} scope
 * @param {*} client_id
 * @param {*} client_secret
 */
export const securityCheck = params => get(USER + "/oauth/token", params);
//获取字典
export const getCommonDictionary = params =>
    get(USER + "/dictionary/" + params, params, true);
//获取城市
export const getDivisionData = params => get(USER + "/district/treeSelect", params, true);
//绑定手机号
export const bindMobile = params =>
  post(MEMBER + "/account/change-mobile", params);


